import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Nav,
  NavbarBrand,
  NavbarToggler,
  NavItem,
  NavLink,
  Badge,
  Button
} from 'reactstrap';
import HeaderDropdown from './HeaderDropdown';
import {GetData} from '../../services/GetData';
import $ from 'jquery';
import SpinnerImg from '../../assets/spinner-rotate.gif';
const GLOBAL = require('../../Globals');
const loaderInner = {
	backgroundColor: 'white',
    marginRight: 'auto',
    marginLeft: 'auto',
    width: '165px',
    fontSize: '17px'
}

class Header extends Component {

  constructor(props) {
    super(props);
	this.state = {
	  _redirect : false
    }
	this.handleClick = this.handleClick.bind(this);
  }
	
  handleClick(){
	  sessionStorage.removeItem('userData');
	  sessionStorage.setItem('isLogged','no');
	  this.setState({_redirect : true});
  }
  
  sidebarToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-hidden');
  }

  sidebarMinimize(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-minimized');
  }

  mobileSidebarToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-mobile-show');
  }

  asideToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('aside-menu-hidden');
  }
  
	componentDidMount() {
	
		this.getsmscount();
		 $("#showLoader").hide();
	}
  
	getsmscount(){
		
		GetData('message/getsmscount').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					count : responseJson
				});
			}
		});
	}

  render() {
	  
	if(this.state._redirect){
		  
		return (<Redirect to='/' />);
	}
	
    return (
      <header className="app-header navbar">
        <NavbarToggler className="d-lg-none" onClick={this.mobileSidebarToggle}>
          <span id="navbar_span" className="navbar-toggler-icon"></span>
        </NavbarToggler>
        <b id="head_scl">SCHOOL</b>
        <NavbarToggler className="d-md-down-none" onClick={this.sidebarToggle}>
          <span className="navbar-toggler-icon"></span>
        </NavbarToggler>
        <div className="head_center"><div id="headsclname">{GLOBAL.Scl_NAME}</div></div>
        <Nav className="ml-auto" navbar>
		  <span id="sms_bal"><b>SMS Balance : </b>&nbsp;<span>{this.state.count}</span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
		  <Button color="secondary" size="sm" onClick={this.handleClick}><i className="fa fa-lock"></i> Logout</Button>
          <HeaderDropdown/>
        </Nav>
         <div id="showLoader" >
			<div id="showLoaderInner">
				<div style={loaderInner} >
					<img src={SpinnerImg} alt="Loading.." style={{ width: '80px' }} />
					<span>Loading...</span>
				</div>						
			</div>
		</div>
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js